import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { INotification } from '@services/notification.service';
import { NotificationStateService } from '@services/notification-state.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-notification-page-item',
  standalone: false,
  templateUrl: './notification-page-item.component.html',
  styleUrls: ['./notification-page-item.component.scss']
})
export class NotificationPageItemComponent {
  @Input() notification!: INotification;

  constructor(
    private router: Router,
    private notificationStateService: NotificationStateService,
    private translateService: TranslateService
  ) {}

  /**
   * Get title in current language
   */
  get title(): string {
    const lang = this.translateService.currentLang || 'en';
    if (lang === 'ar') {
      return this.notification.title.ar;
    }
    return this.notification.title.en || this.notification.title.ar;
  }

  /**
   * Get body in current language
   */
  get body(): string {
    const lang = this.translateService.currentLang || 'en';
    if (lang === 'ar') {
      return this.notification.body.ar;
    }
    return this.notification.body.en || this.notification.body.ar;
  }

  /**
   * Check if notification is clickable (has purchaseOrderId)
   */
  get isClickable(): boolean {
    return !!this.notification.data?.purchaseOrderId;
  }

  /**
   * Handle notification click
   */
  onClick(): void {
    // Mark as read if not already read
    if (!this.notification.isRead) {
      this.notificationStateService.markAsRead(this.notification._id);
    }

    // Navigate to order if purchaseOrderId exists
    if (this.notification.data?.purchaseOrderId) {
      this.router.navigate(['/orders', this.notification.data.purchaseOrderId]);
    }
  }

  /**
   * Get time ago string
   */
  getTimeAgo(): string {
    const createdAt = new Date(this.notification.created_at);
    const now = new Date();
    const diffInMs = now.getTime() - createdAt.getTime();
    const diffInMinutes = Math.floor(diffInMs / 60000);
    const diffInHours = Math.floor(diffInMinutes / 60);
    const diffInDays = Math.floor(diffInHours / 24);

    if (diffInMinutes < 1) {
      return 'Just now';
    } else if (diffInMinutes < 60) {
      return `${diffInMinutes}m ago`;
    } else if (diffInHours < 24) {
      return `${diffInHours}h ago`;
    } else if (diffInDays < 7) {
      return `${diffInDays}d ago`;
    } else {
      return createdAt.toLocaleDateString();
    }
  }
}
